var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column w-100 vh-100"},[_c('header',{staticClass:"mw-100"},[_c('c-topbar',{attrs:{"sidebar-pinned":_vm.pinned,"settings":_vm.$Settings.get('ui.topbar', {}),"labels":{
        helpForum: _vm.$t('help.forum'),
        helpDocumentation: _vm.$t('help.documentation'),
        helpFeedback: _vm.$t('help.feedback'),
        helpVersion: _vm.$t('help.version'),
        userSettingsLoggedInAs: _vm.$t('userSettings.loggedInAs', { user: _vm.user }),
        userSettingsProfile: _vm.$t('userSettings.profile'),
        userSettingsChangePassword: _vm.$t('userSettings.changePassword'),
        userSettingsLogout: _vm.$t('userSettings.logout'),
      }},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('portal-target',{attrs:{"name":"topbar-title"}})]},proxy:true},{key:"tools",fn:function(){return [_c('portal-target',{attrs:{"name":"topbar-tools"}})]},proxy:true},{key:"avatar-dropdown",fn:function(){return [_c('portal-target',{attrs:{"name":"topbar-avatar-dropdown"}})]},proxy:true}])})],1),_c('aside',[_c('c-sidebar',{attrs:{"expanded":_vm.expanded,"pinned":_vm.pinned,"icon":_vm.icon,"logo":_vm.logo,"disabled-routes":_vm.disabledRoutes,"expand-on-hover":"","right":_vm.textDirectionality() === 'rtl'},on:{"update:expanded":function($event){_vm.expanded=$event},"update:pinned":function($event){_vm.pinned=$event}},scopedSlots:_vm._u([{key:"header-expanded",fn:function(){return [_c('portal-target',{attrs:{"name":"sidebar-header-expanded"}})]},proxy:true},{key:"body-expanded",fn:function(){return [_c('portal-target',{attrs:{"name":"sidebar-body-expanded"}})]},proxy:true},{key:"footer-expanded",fn:function(){return [_c('portal-target',{attrs:{"name":"sidebar-footer-expanded"}})]},proxy:true}])})],1),_c('main',{staticClass:"d-inline-flex h-100 overflow-auto d-print-flex"},[[_c('div',{staticClass:"spacer d-print-none",class:{
          'expanded': _vm.expanded && _vm.pinned,
        }})],_c('router-view')],2),_c('c-prompts'),_c('c-toaster',{attrs:{"toasts":_vm.toasts}}),_c('c-permissions-modal',{attrs:{"labels":{
      save: _vm.$t('permissions:ui.save'),
      cancel: _vm.$t('permissions:ui.cancel'),
      loading: _vm.$t('permissions:ui.loading'),
      edit: {
        label: _vm.$t('permissions:ui.edit.label'),
        description: _vm.$t('permissions:ui.edit.description'),
      },
      evaluate: {
        label: _vm.$t('permissions:ui.evaluate.label'),
        description: _vm.$t('permissions:ui.evaluate.description'),
      },
      add: {
        label: _vm.$t('permissions:ui.add.label'),
        title: _vm.$t('permissions:ui.add.title'),
        save: _vm.$t('permissions:ui.add.save'),
        role: {
          label: _vm.$t('permissions:ui.add.role.label'),
          placeholder: _vm.$t('permissions:ui.add.role.placeholder'),
        },
        user: {
          label: _vm.$t('permissions:ui.add.user.label'),
          placeholder: _vm.$t('permissions:ui.add.user.placeholder'),
        },
      },
    }}}),_c('c-translation-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }